import script from "./ValidatorMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorMetrics.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorMetrics.vue?vue&type=style&index=0&id=4a2be5b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2be5b6"]])

export default __exports__